function OffsetCarousel(index, element, options) {
  this.$element = $(element);
  this.index = index;

  console.log("CODE UPDATE 5");

  this.selectors = {
    wrapper: ".carousel",
    slider: ".carousel__slides",
    items: ".carousel__item",
    image: ".carousel__item img"
  };

  this.states = {
    wrapper: {
      IS_INITIALIZED: "carousel--is-initialized"
    }
  };

  // Default options
  const defaultOptions = {
    cellSelector: this.selectors.items,
    selectedAttraction: 0.2,
    friction: 0.8,
    groupCells: true,
    wrapAround: false,
    prevNextButtons: true,
    contain: true,
    cellAlign: "left",
    pageDots: false,
    cellAlignMobile: "center", // Default mobile cellAlign option
    containMobile: false, // Default mobile contain option
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  };

  this.options = Object.assign({}, defaultOptions, options);

  // The additional margin that can be used whether to make the transition
  // to a slider sooner or later.
  this.viewportOffset = 0;

  this.initialize = function () {
    this.$wrapper = this.$element.find(this.selectors.wrapper);
    this.$slider = this.$element.find(this.selectors.slider);
    this.$items = this.$element.find(this.selectors.items);
    this.$image = this.$element.find(this.selectors.image);

    this.carouselInMobile = this.$wrapper.data("carousel-on-mobile");

    // If the wrapper cannot be found, check if the component itself is the carousel.
    if (
      !this.$wrapper.length &&
      this.$element.hasClass(this.selectors.wrapper.replace(".", ""))
    )
      this.$wrapper = this.$element;

    // If window viewport changes, determine slider state and reset min-height.
    $(window)
      .on("resize orientationchange", debounce(this.determineSliderState.bind(this), 200))
      .on("orientationchange resize", this._handleResize.bind(this));

    this.$image.on("load", () => $(window).trigger("resize"));

    // Determine slider state on initialization.
    this.determineSliderState();

    // if (this.options.addOffset) {
    //   this.adjustSlideOffset();
    // }
  };

  this.isInitialized = function () {
    return this.$wrapper.hasClass(this.states.wrapper.IS_INITIALIZED);
  };

  this.initializeSlider = function () {
    let options = this.options;

    if (!this.carouselInMobile && this.isMobile()) {
      options = Object.assign({}, options, {
        cellAlign: options.cellAlignMobile, // Set mobile cellAlign option
        contain: options.containMobile, // Set mobile contain option
        pageDots: options.pageDotsOnMobile
      });
    }

    if (!this.isMobile()) {
      // Add or remove the extra slide based on screen size
      // Add an extra slide at the end
      const $extraSlide = $('<div class="carousel__item spacer"></div>').css(
        "width",
        "88px"
      );
      // this.$slider.append($extraSlide);
      // console.log('desktop');
    } else {
      // Remove the extra slide
      // this.$slider.find(".carousel__item.spacer:last-child").remove();
      // console.log('mobile');
    }

    // Initialize slider.
    this.$slider.flickity(options);
    this.$slider.addClass( "with-offset" );

    this.$wrapper.addClass(this.states.wrapper.IS_INITIALIZED);

    this.preventClicksWhileDragging();
  };

  this.destroySlider = function () {
    // Only destroy when Flickity is initialized.
    if (this.isInitialized()) {
      this.$slider.flickity("destroy");

      this.$wrapper.removeClass(this.states.wrapper.IS_INITIALIZED);
    }
  };

  this.hasReachedViewportEdge = function () {
    // Get total width of items when combined.
    let totalWidth = 0;

    // Loop through the items to get the total width.
    this.$items.each(function () {
      totalWidth += $(this).outerWidth(true);
    });

    // Check if the wrapper has reached the edges of the viewport.
    return totalWidth - this.viewportOffset >= $(window).width();
  };

  this.determineSliderState = function () {
    const hasReachedViewportEdge = this.hasReachedViewportEdge();

    // If the wrapper has reached the edge, turn the carousel into a slider.
    if (hasReachedViewportEdge) {
      this.initializeSlider();
    } else {
      this.destroySlider();
    }
  };

  this.refresh = function () {
    if (this.isInitialized()) {
      this.$slider.flickity("reloadCells");
      this.$slider.flickity("select", 0);
    }
  };

  this._handleResize = function (event) {
    // When the window resizes, reset the min-height of the items;
    // then, trigger resize and revert to the min-height on the CSS.
    if (this.isInitialized()) {
      this.$items.css("min-height", "initial");
      this.$slider.flickity("resize");
      this.$items.css("min-height", "");
    }
  };

  this.preventClicksWhileDragging = function () {
    // prevent click events (e.g., video play/pause) from happening when dragging the slider
    let flkty = this.$slider.data("flickity");
    flkty.on("dragStart", () =>
      // flkty.slider.childNodes.forEach((slide) => (slide.style.pointerEvents = "none"));
      $.each(flkty.cells, (i,e) => $( e.element ).css( "pointer-events", "none" ) )
    );
    flkty.on("dragEnd", () =>
      // flkty.slider.childNodes.forEach((slide) => (slide.style.pointerEvents = "all"))
      $.each(flkty.cells, (i, e) => $(e.element).css("pointer-events", ""))
    );
  };

  this.adjustSlideOffset = function () {
    $(window).on("resize", debounce(this.calculateOffsetBasedOnScreenSize.bind(this), 200));
    this.calculateOffsetBasedOnScreenSize();
  };

  this.calculateOffsetBasedOnScreenSize = function () {
    if (this.isInitialized()) {
      const screenWidth = $(window).width();
      let offset = 0;

      if (screenWidth <= 640) {
        offset = 0;
      } else if (screenWidth <= 1024) {
        offset = 16;
      } else if (screenWidth <= 1440) {
        offset = 28;
      } else {
        offset = 48;
      }

      // const $slides = this.$slider.find(".carousel__item");
      // $slides.css("transform", `translateX(${offset}px)`);
    } else {
      // const $slides = this.$slider.find(".carousel__item");
      // $slides.css("transform", `translateX(0px)`);
    }
  };

  this.isMobile = function () {
    return window.innerWidth < 640;
  };

  this.initialize();
}
  


/*
class MFROffsetCarousel {
    constructor( i, e, args ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            dots: ".flickity-page-dots .dot"
        }

        this.args = args;

        this.options = {
            selectedAttraction: 0.1,
            friction: 0.55,
            prevNextButtons: true,
            contain: true,
            cellAlign: "left",
            pageDots: false,
            wrapAround: false,
            groupCells: false,
            imagesLoaded: true,
            on: {
                ready: () => {
                  this.initCarouselEvents();
                  this.adjustSlidesTransform();
                }
              }
        }

        if (args && args.flickityOptions) this.replaceOptions(args.flickityOptions);

        
        this.init();
    }

    init() {
        this.updateOptionsBasedOnScreenSize();
        this.$element.flickity(this.options);
    
        if (this.args && this.args.navButtons) this.initCustomNav();
        
        $(window).on("resize", () => {
            this.adjustSlidesTransform();
        });
      }


    initCarouselEvents() {
        this.__handleSliderChange();
        this.$element.on( "change.flickity", this.__handleSliderChange.bind( this ) );
    }

    __handleSliderChange(e, i) {
        const selected = this.$element.find( ".flickity-page-dots .dot.is-selected" );
        const beforeSelected = selected.prev( ".dot" );
        const afterSelected = selected.next( ".dot" );
        const alongsideClass = "alongside-selected";
        const dots = this.$element.find( this.selectors.dots );

        dots.removeClass( alongsideClass );

        beforeSelected.addClass( alongsideClass );
        afterSelected.addClass( alongsideClass );

        this.updateNav( i );
    }

    replaceOptions( options ) {
        $.each( options, ( i, e ) => {
            this.options[i] = e;
        } )
    }

    //add an offset to the left of each slide to give it left margin but go off the screenon the right side still
    adjustSlidesTransform() { 
        const offset = this.calculateOffsetBasedOnScreenSize();
        const $slides = this.$element.find(".blog-carousel__item");
        $slides.css("transform", `translateX(${offset}px)`);
    }
    //adjust the offset based on the different margins that .grid-gutter has at different breakpoints
    calculateOffsetBasedOnScreenSize() {
        const screenWidth = $(window).width();
        let offset = 0;
    
        if (screenWidth <= 1024) {
          offset = 16;
        } else if (screenWidth <= 1440) {
          offset = 28;
        } else {
          offset = 48;
        }
    
        return offset;
    }

    updateOptionsBasedOnScreenSize() {
        const screenWidth = $(window).width();
    
        if (screenWidth <= 639) {
          this.options.cellAlign = "center";
          this.options.contain = false;
        }
      }

    replaceOptions(options) {
        $.each(options, (i, e) => {
            this.options[i] = e;
        });
    }

    initCustomNav() {
        this.$element.closest( "section" ).find( `${ this.args.navButtons }.previous` ).on( "click", () => this.$element.flickity( "previous" ) )
        this.$element.closest( "section" ).find( `${ this.args.navButtons }.next` ).on( "click", () => this.$element.flickity( "next" ) )
    }

    updateNav(i) {
        if( i === undefined || !this.args || !this.$element.closest( "section" ).find( this.args.navButtons ).length ) return;
        this.$element.closest( "section" ).find( `${ this.args.navButtons }` ).removeClass( "disabled" );
        if( i == 0 ) this.$element.closest( "section" ).find( `${ this.args.navButtons }.previous` ).addClass( "disabled" );
        if( i == this.$element.data( "flickity" ).cells.length - 1 ) this.$element.closest( "section" ).find( `${ this.args.navButtons }.next` ).addClass( "disabled" );
    }
}
*/